export const DEFAULT_NOTIFICATION_TIMEOUT = 1000;
